'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postExternalApiEvent = undefined;

var _createPostMessageAction = require('../../post-message/actions/createPostMessageAction');

var _externalApiEventsPostMessageTypes = require('../constants/externalApiEventsPostMessageTypes');

var postMessageAction = (0, _createPostMessageAction.createPostMessageAction)(_externalApiEventsPostMessageTypes.EXTERNAL_API_EVENT);

var postExternalApiEvent = exports.postExternalApiEvent = function postExternalApiEvent(_ref) {
  var eventType = _ref.eventType,
      payload = _ref.payload;
  return function (dispatch) {
    dispatch(postMessageAction({ eventType: eventType, payload: payload }));
  };
};